export const TranslocoCacheTime = 1000 * 60 * 60 * 24; // 1 day
